export default function FormSection({
    title,
    icon,
    description,
    children,
    className = '',
}) {
    return (
        <div className={`card mb-4 ${className}`}>
            <div className="card-header">
                <h5 className="card-title mb-0">
                    {icon && <i className={`bi ${icon} me-2`}></i>}
                    {title}
                </h5>
            </div>
            <div className="card-body">
                {description && (
                    <p className="text-muted small mb-3">{description}</p>
                )}
                <div className="row g-3">
                    {children}
                </div>
            </div>
        </div>
    );
}
